// How long the chart takes to play the trade from the entry to its end
export const REPLAY_DURATION_MS = 2500;

// Candles of the trade: the interval is picked to fit at most this many
export const MAX_TRADE_CANDLES = 60;

// How the trade is shown, by the number of candles it lasted
export const CHART_VIEW = {
  // One candle: no chart, the multiplier on a scale
  SUMMARY: "summary",
  // A few candles: line of the closes over a filled area
  LINE: "line",
  CANDLES: "candles",
};
export const LINE_CHART_MAX_CANDLES = 12;

// Multiplier scale of the summary view, 0x … 10x
export const MULTIPLIER_SCALE_MAX = 10;
export const MULTIPLIER_SCALE_BARS = 32;

export const CANDLES_STATUS = {
  LOADING: "loading",
  READY: "ready",
  EMPTY: "empty",
  ERROR: "error",
};

// Canvas can't read Sass variables: the colors of the main chart's trade marks
// and of the modals (TradeModals/_variables.sass)
export const CHART_COLORS = {
  up: "#00AD64",
  down: "#FE3D31",
  entry: "#FF6C22",
  markerStroke: "#0F1113",
  grid: "#1C1E23",
  label: "#717985",
  crosshair: "#FFFFFF",
  // Top of the area under the line chart, it fades out downwards
  areaUp: "rgba(0, 173, 100, 0.35)",
  areaDown: "rgba(254, 61, 49, 0.35)",
  areaEnd: "rgba(0, 0, 0, 0)",
};

export const CHART_FONT = '500 11px "IBM Plex Sans", sans-serif';

// Half of $modal-entry-badge-size: keeps the badge inside the chart at x = 0
export const ENTRY_BADGE_RADIUS = 8;
